import Vue from "vue";
import Vuex from "vuex";
import { getGiftvote } from "@/api/Api";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    giftvoteImages: null, // 无需授权的背景图等，供各页面优先展示
    refreshIndex: false, // 从 Launch 进入首页时需强制刷新列表
    activityInfo: null, // Launch show 数据缓存，绑定后进首页复用
    nameBound: false, // 本次会话是否刚在 Launch 完成绑定
  },
  getters: {
    giftvoteImages: (s) => s.giftvoteImages,
  },
  mutations: {
    setGiftvoteImages(state, data) {
      state.giftvoteImages = data;
    },
    setRefreshIndex(state, value) {
      state.refreshIndex = value;
    },
    setActivityInfo(state, data) {
      state.activityInfo = data;
    },
    setNameBound(state, value) {
      state.nameBound = value;
    },
  },
  actions: {
    async fetchGiftvoteImages({ commit }) {
      try {
        const res = await getGiftvote();
        commit("setGiftvoteImages", (res && res.data) || {});
      } catch (e) {
        commit("setGiftvoteImages", null);
      }
    },
  },
  modules: {},
});
